import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { SiteTeamsListModule } from '@portal-core/sites/components/site-teams-list/site-teams-list.module';
import { TeamAvatarModule } from '@portal-core/teams/components/team-avatar/team-avatar.module';
import { TeamsSelectListModule } from '@portal-core/teams/components/teams-select-list/teams-select-list.module';
import { TeamAsyncModule } from '@portal-core/teams/pipes/team-async/team-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { DropdownArrowModule } from '@portal-core/ui/forms/components/dropdown-arrow/dropdown-arrow.module';
import { FilterBarModule } from '@portal-core/ui/page-filters/components/filter-bar/filter-bar.module';
import { PopupModule } from '@portal-core/ui/popup/popup.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { SiteAccessFormComponent } from './site-access-form.component';

@NgModule({
  declarations: [SiteAccessFormComponent],
  imports: [
    McColorModule,
    AutocompleteInputModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    FormsModule,
    LoaderModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTabsModule,
    TeamAvatarModule,
    TeamAsyncModule,
    FilterBarModule,
    PopupModule,
    DropdownArrowModule,
    MatInputModule,
    TeamsSelectListModule,
    SiteTeamsListModule
  ],
  exports: [SiteAccessFormComponent]
})
export class SiteAccessFormModule { }
